export const ALL_VIEWS = [
  "dashboard", "cqc-hq", "audit-engine", "action-plans", "intelligence",
  "admissions", "admissions-bundle", "enhanced-admissions", "residents", "resident-360", "bulk-upload", "reconciliation", "dependency-pricing", "dependency-tool", "wellbeing", "activities", "end-of-life", "wound-care", "safeguarding", "medication-checks", "medication-suite", "med-competency", "ipc", "dols", "mca-hub", "call-log", "shift-handover", "walkarounds",
  "dining", "cleaning", "stock", "file-vault",
  "policies", "staff", "staff-wellbeing", "training", "feedback", "you-said-we-did",
  "audits", "deep-audit", "cqc-action-plan", "compliance", "cqc-readiness", "reports", "deadlines", "evidence-pack", "near-miss", "trends", "partnerships", "scrutiny", "hardening", "lifecycle-test", "user-guide", "settings",
];

const SENIOR = [
  "dashboard", "cqc-hq", "audit-engine", "action-plans", "intelligence", "admissions", "admissions-bundle", "enhanced-admissions", "residents", "resident-360", "dependency-pricing", "dependency-tool", "wellbeing", "activities", "end-of-life", "wound-care", "safeguarding", "medication-checks", "medication-suite", "med-competency", "ipc", "dols", "mca-hub", "call-log", "shift-handover", "walkarounds",
  "dining", "cleaning", "stock", "file-vault",
  "policies", "staff-wellbeing", "training", "feedback", "you-said-we-did",
  "audits", "deep-audit", "cqc-action-plan", "compliance", "deadlines", "evidence-pack", "near-miss", "trends", "partnerships", "scrutiny", "hardening", "lifecycle-test", "user-guide",
];

const CARER = [
  "dashboard", "action-plans",
  "admissions-bundle", "dependency-tool", "wellbeing", "activities", "end-of-life", "wound-care", "safeguarding", "medication-checks", "medication-suite", "med-competency", "ipc", "dols", "mca-hub", "call-log", "shift-handover", "walkarounds",
  "dining", "cleaning",
  "policies", "staff-wellbeing", "training", "feedback", "you-said-we-did", "near-miss",
];

const KITCHEN = ["dashboard", "dining", "stock", "cleaning", "policies", "training", "call-log", "feedback"];
const DOMESTIC = ["dashboard", "cleaning", "stock", "policies", "training", "call-log", "feedback"];
const MAINTENANCE = ["dashboard", "stock", "walkarounds", "policies", "training", "call-log", "feedback"];

export const USER_VIEW_OVERRIDES: Record<string, string[]> = {
  // Optional per-person override, keyed by login username, email or name in lower case.
};

export function allowedViewsFor(user: any): string[] {
  const key = String((user && (user.username || user.email || user.name)) || "").toLowerCase();

  if (USER_VIEW_OVERRIDES[key]) return USER_VIEW_OVERRIDES[key];

  const role = String((user && user.role) || "").toLowerCase();

  let views: string[];

  if (role.includes("super") || role.includes("director") || role.includes("nominated")) {
    views = ALL_VIEWS;
  } else if (role.includes("manager") || role.includes("deputy")) {
    views = ALL_VIEWS;
  } else if (role.includes("nurse") || role.includes("senior") || role.includes("lead")) {
    views = SENIOR;
  } else if (role.includes("kitchen") || role.includes("chef")) {
    views = KITCHEN;
  } else if (role.includes("domestic") || role.includes("housekeeping")) {
    views = DOMESTIC;
  } else if (role.includes("maintenance") || role.includes("handyman")) {
    views = MAINTENANCE;
  } else if (role.includes("admin") || role.includes("office")) {
    views = ALL_VIEWS.filter(view => view !== "settings");
  } else {
    views = CARER;
  }

  const financePrivileged = ["super", "director", "owner", "nominated"].some(token => role.includes(token));

  if (!financePrivileged) {
    views = views.filter(view => 
      view !== "reconciliation" && 
      view !== "residents" && 
      view !== "bulk-upload"
    );
  }

  return views;
}

export const SESSION_TIMEOUT_MS = 5 * 60 * 1000;